import { useLocation } from 'react-router-dom';
import { useShellAppContext } from './useShellAppContext';

const APP_SHOP_PATH = /^\/app\/([^/]+)(?:\/|$)/;

/**
 * Nested SearchRouter routes are built from a resolved URL, so their local
 * react-router match no longer carries the parent shop parameter. The shell
 * context is canonical in embedded mode; the URL fallback keeps standalone
 * and component-test routes deterministic.
 */
export const useRouteShopId = () => {
  const { routeShopId } = useShellAppContext();
  const location = useLocation();
  if (routeShopId) return String(routeShopId);
  const match = location.pathname.match(APP_SHOP_PATH);
  return match ? decodeURIComponent(match[1]) : null;
};

export default useRouteShopId;
